import { asyncRoutes, constantRoutes } from '@/router';

/**
 * Check if it matches the current user right by meta.role
 * @param {String[]} roles
 * @param {String[]} permissions
 * @param route
 */
function hasExplicitAccessMeta(meta) {
  return !!(
    (meta.roles && meta.roles.length > 0) ||
    (meta.permissions && meta.permissions.length > 0)
  );
}

function canAccess(roles, permissions, route, isSuperviseurGrade) {
  if (route.hidden) {
    return false;
  }

  if (route.meta) {
    if (route.meta.superviseurOnly && !isSuperviseurGrade) {
      return false;
    }

    if (isSuperviseurGrade && !route.meta.superviseurOnly && !hasExplicitAccessMeta(route.meta)) {
      return false;
    }

    let hasRole = true;
    let hasPermission = true;
    if (route.meta.roles || route.meta.permissions) {
      // If it has meta.roles or meta.permissions, accessible = hasRole || permission
      hasRole = false;
      hasPermission = false;
      if (route.meta.roles && route.meta.roles.length > 0) {
        hasRole = roles.some(role => route.meta.roles.includes(role));
      }

      if (route.meta.permissions && route.meta.permissions.length > 0) {
        hasPermission = permissions.some(permission => route.meta.permissions.includes(permission));
        if (
          !hasPermission &&
          isSuperviseurGrade &&
          route.meta.superviseurOnly &&
          route.meta.permissions.includes('superviser activites')
        ) {
          hasPermission = true;
        }
      }
    }

    return hasRole || hasPermission;
  }

  if (isSuperviseurGrade) {
    return false;
  }

  // If no meta.roles/meta.permissions inputted - the route should be accessible
  return true;
}

/**
 * Find all routes of this role
 * @param routes asyncRoutes
 * @param roles
 */
function filterAsyncRoutes(routes, roles, permissions, isSuperviseurGrade) {
  const res = [];

  routes.forEach(route => {
    const tmp = { ...route };

    if (tmp.children) {
      tmp.children = filterAsyncRoutes(
        tmp.children,
        roles,
        permissions,
        isSuperviseurGrade
      );
      if (tmp.children.length === 0) {
        return;
      }
      res.push(tmp);
      return;
    }

    if (canAccess(roles, permissions, tmp, isSuperviseurGrade)) {
      res.push(tmp);
    }
  });

  return res;
}

const state = {
  routes: [],
  addRoutes: [],
};

const mutations = {
  SET_ROUTES: (state, { menuRoutes, accessedRoutes }) => {
    state.addRoutes = accessedRoutes;
    state.routes = menuRoutes;
  },
};

const actions = {
  generateRoutes({ commit }, { roles, permissions, isSuperviseurGrade = false }) {
    return new Promise(resolve => {
      let accessedRoutes;
      let menuRoutes;
      if (roles.includes('admin')) { // Toutes les routes si admin
        accessedRoutes = asyncRoutes || [];
        menuRoutes = constantRoutes.concat(accessedRoutes);
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles, permissions, isSuperviseurGrade);
        const filteredConstantRoutes = filterAsyncRoutes(
          constantRoutes,
          roles,
          permissions,
          isSuperviseurGrade
        );
        menuRoutes = filteredConstantRoutes.concat(accessedRoutes);
      }

      commit('SET_ROUTES', { menuRoutes, accessedRoutes });
      resolve(accessedRoutes);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
